import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { Tracking } from '@panamax/app-state';
import { DID_YOU_FORGET_TRACING_ACTIONS } from './did-you-forget-tracing.actions';
import { DidYouForgetTracingConstants } from './did-you-forget-tracing.constants';
import { loadDYFPageTraceTransformer } from './did-you-forget-trace.transformers';
import { DyfViewModel } from '@order/models/dyf-view-model';

@Injectable({
  providedIn: 'root',
})
export class DidYouForgetTracingService {
  constructor(private store: Store) {}

  tracePageLoad = (dyfVM: DyfViewModel) => {
    const tracking: Tracking = {
      tracing: {
        data: {
          traceContext: DidYouForgetTracingConstants.capability,
          isEndOfTrace: true,
          isStartOfTrace: true,
          attributes: {
            order: {
              orderId: dyfVM.orderHeader?.orderId,
              tandemOrderNumber: dyfVM.orderHeader?.tandemOrderNumber,
              requestedDeliveryDate: dyfVM.orderHeader?.requestedDeliveryDate,
              confirmedDeliveryDate: dyfVM.orderHeader?.confirmedDeliveryDate,
            },
            dyfProductCount: dyfVM?.products?.length,
            inspiredPicksProductCount: dyfVM?.inspiredPicks?.products?.length,
            event: DidYouForgetTracingConstants.event,
          },
        },
        transformFunc: loadDYFPageTraceTransformer,
      },
    };

    this.store.dispatch(
      DID_YOU_FORGET_TRACING_ACTIONS.traceLoadPage({ tracking }),
    );
  };
}
